const headers = [
  { text: 'Tiêu đề', value: 'title', width: '300px' },
  { text: 'Người tạo', value: 'createdBy', width: '100px' },
  { text: 'Ngày tạo', value: 'createdAt', width: '100px' },
  { text: 'Ngày hết hạn', value: 'deadline', width: '100px' },
  { text: 'Trạng thái hiển thị', value: 'status', width: '100px' },
  { text: 'Trạng thái hết hạn', value: 'isExpired', width: '100px' },
  { text: 'Đã tham gia', value: 'countReply', align: 'right', width: '100px' },
  { text: 'Thao tác', value: 'actions', width: '80px' }
]

export { headers }
